import React from 'react';
import { Button, Square, Stack } from '@grubhubprod/gh-cookbook-react';

interface DialogFooterProps {
  confirmLabel: string;
  isConfirmButtonDisabled: boolean;
  isUploadAnotherCSVDisabled: boolean;

  onConfirm: () => void;
  onUploadAnotherCSV: () => void;
}

export function DialogFooter({
  confirmLabel,
  isConfirmButtonDisabled,
  isUploadAnotherCSVDisabled,
  onConfirm,
  onUploadAnotherCSV,
}: DialogFooterProps): JSX.Element {
  return (
    <Square as="footer" dimension="2" inset="md">
      <Stack y="x-sm">
        <Button
          block
          variant="primary"
          buttonSize="medium"
          disabled={isConfirmButtonDisabled}
          onClick={onConfirm}
        >
          {confirmLabel}
        </Button>
      </Stack>
      <Button
        block
        variant="tertiary"
        buttonSize="medium"
        disabled={isUploadAnotherCSVDisabled}
        onClick={onUploadAnotherCSV}
      >
        Upload another CSV
      </Button>
    </Square>
  );
}
